export const browserNotificationInteractionFactory = ({
  templateId,
  typeId
}, {
  origin
}) => ({
  origin: JSON.stringify(origin),
  template: templateId,
  type: typeId
});